
export class AlertHistory {
    public userId: string;
    public dateModified: number;

    constructor(init?: Partial<AlertHistory>) {
        Object.assign(this, init);
    }
}
